import React from 'react';

interface FeedingData {
  type: string;
  ablactation_start_month: number | null;
  formula_name: string;
  food_allergies: string;
}

interface Props {
  feeding: FeedingData;
  setPediatricField: (section: string, field: string, value: any) => void;
}

const FEEDING_TYPES = [
  { value: 'materna_exclusiva', label: 'Materna Exclusiva' },
  { value: 'materna_mixta', label: 'Materna Mixta' },
  { value: 'formula', label: 'Fórmula' },
  { value: 'ablactacion', label: 'Ablactación' },
  { value: 'complementaria', label: 'Complementaria' },
];

const FeedingSection: React.FC<Props> = ({ feeding, setPediatricField }) => {
  const set = (field: string, value: any) => setPediatricField('feeding', field, value);

  const showAblactacion = feeding.type !== '' && feeding.type !== 'materna_exclusiva';
  const showFormula = feeding.type === 'formula' || feeding.type === 'materna_mixta';

  return (
    <div className="card mb-3">
      <div className="card-body">
        <h5 className="card-title">Alimentación</h5>
        <div className="row mt-3">
          <div className="col-md-3">
            <div className="mb-3">
              <label className="form-label">Tipo de Lactancia</label>
              <select
                className="form-control"
                value={feeding.type}
                onChange={(e) => set('type', e.target.value)}
              >
                <option value="">Seleccionar...</option>
                {FEEDING_TYPES.map((ft) => (
                  <option key={ft.value} value={ft.value}>{ft.label}</option>
                ))}
              </select>
            </div>
          </div>
          {showAblactacion && (
            <div className="col-md-3">
              <div className="mb-3">
                <label className="form-label">Inicio de Ablactación (meses)</label>
                <input
                  type="number"
                  className="form-control"
                  min={0}
                  max={24}
                  value={feeding.ablactation_start_month ?? ''}
                  onChange={(e) => set('ablactation_start_month', e.target.value ? Number(e.target.value) : null)}
                  placeholder="0-24"
                />
              </div>
            </div>
          )}
          {showFormula && (
            <div className="col-md-3">
              <div className="mb-3">
                <label className="form-label">Nombre de la Fórmula</label>
                <input
                  type="text"
                  className="form-control"
                  value={feeding.formula_name}
                  onChange={(e) => set('formula_name', e.target.value)}
                  placeholder="Ej: Similac, Enfamil..."
                />
              </div>
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Alergias Alimentarias</label>
              <textarea
                className="form-control"
                rows={2}
                value={feeding.food_allergies}
                onChange={(e) => set('food_allergies', e.target.value)}
                placeholder="Registre alergias o intolerancias conocidas..."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedingSection;
